import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { SIMPLE_VALUE_PROP, SIMPLE_ARRAY_PROP } from 'ui/consts/prop-types';
import { wire } from 'ui/hoc/prop-wire';
import normalizeList from './list-normalizer'; // import Checkbox from 'ui/components/checkbox'

import Checkbox from './checkbox';

var log = require('loglevel').getLogger('react-ui/components/checkbox-group');
/**
 * A React Checkbox Group
 * @constructor
 * @param {string} [id] - Container dom element #id
 * @param {Array.<object>} list - List of items
 * @param {string | number} list.value - item value
 * @param {renderable} list.text - item display text
 * @param {string} list.className - item classname
 * @param {renderable} [list.children] - things to render after the label
 * @param {string} [className] - Classname for the container
 * @param {Array.<string|number>} [defaultValue] - Default checked values
 * @param {Array.<string|number>} [value] - Current checked values
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean|Array.<string|number>} [disabled=false] - true/false if disable all checkboxes, or array of values to disable specific checkboxes
 * @param {boolean} [toggleAll=false] - Show toggle all checkbox?
 * @param {string} [toggleAllText='All'] - Text shown in toggle all label
 * @param {function} [onChange] - Callback function when any of the checkboxes is ticked/unticked. <br> Required when value prop is supplied
 * @param {Array.<string|number>} onChange.values - current checked values
 * @param {object} onChange.eventInfo - event related info
 * @param {Array.<string|number>} onChange.eventInfo.before - previously checked values
 * @param {string|number} onChange.eventInfo.value - which value triggered change?
 * @param {boolean} onChange.eventInfo.checked - checked or unchecked?
 *
 * @example
// controlled

import {CheckboxGroup} from 'react-ui'
React.createClass({
    getInitialState() {
        return {
            movies:[1]
        }
    },
    handleChange(movies) {
        this.setState({movies})
    },
    render() {
        let {movies} = this.state;
        return <div>
            <label>Select movies</label>
            <CheckboxGroup
                list={[
                    {value:1,text:'1d - Finding Dory (selected by default, cannot deselect)'},
                    {value:2,text:'2 - Wizard of Oz'},
                    {value:3,text:'3 - Citizen Kane'}
                ]}
                onChange={this.handleChange}
                value={movies}
                disabled={[1]}/>
        </div>
    }
})
 */


var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  var _super = _createSuper(CheckboxGroup);

  function CheckboxGroup() {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getDisabledItems", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          list = _this$props.list;
      var disabledItems = [];

      if (_.isBoolean(disabled)) {
        if (disabled) {
          disabledItems = _.map(list, 'value');
        } else {
          disabledItems = [];
        }
      } else if (_.isArray(disabled)) {
        disabledItems = disabled;
      }

      return disabledItems;
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectableItems", function () {
      var list = _this.props.list;
      return _.without.apply(_, [_.map(list, 'value')].concat(_toConsumableArray(_this.getDisabledItems())));
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, checked) {
      var _this$props2 = _this.props,
          curValue = _this$props2.value,
          onChange = _this$props2.onChange;
      var newValue = checked ? [].concat(_toConsumableArray(curValue), [value]) : _.without(curValue, value);
      onChange(newValue, {
        value: value,
        checked: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleAll", function (checked) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;

      var disabledItems = _this.getDisabledItems();

      var selectableItems = _this.getSelectableItems();

      var disabledSelectedItems = _.intersection(disabledItems, value);

      var newValue = checked ? [].concat(_toConsumableArray(selectableItems), _toConsumableArray(disabledSelectedItems)) : disabledSelectedItems;
      onChange(newValue, {
        checked: checked
      });
    });

    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          id = _this$props4.id,
          toggleAll = _this$props4.toggleAll,
          toggleAllText = _this$props4.toggleAllText,
          className = _this$props4.className,
          list = _this$props4.list,
          value = _this$props4.value;
      var disabledItems = this.getDisabledItems();

      var numSelected = _.without.apply(_, [value].concat(_toConsumableArray(disabledItems))).length;

      var numSelectable = this.getSelectableItems().length;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: cx('c-checkbox-group', className)
      }, toggleAll && numSelectable > 0 && /*#__PURE__*/React.createElement("span", {
        className: "all list-item"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        id: id + '-_all',
        checked: numSelected > 0,
        className: cx({
          partial: numSelected > 0 && numSelected < numSelectable
        }),
        onChange: this.handleToggleAll
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: id + '-_all'
      }, toggleAllText)), _.map(list, function (_ref) {
        var itemValue = _ref.value,
            itemText = _ref.text,
            itemClassName = _ref.className,
            children = _ref.children;
        return /*#__PURE__*/React.createElement("span", {
          className: cx('list-item', itemClassName),
          key: itemValue
        }, /*#__PURE__*/React.createElement(Checkbox, {
          id: id + '-' + itemValue,
          onChange: _this2.handleChange.bind(_this2, itemValue),
          value: itemValue,
          checked: value.indexOf(itemValue) >= 0,
          disabled: _.includes(disabledItems, itemValue)
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: id + '-' + itemValue
        }, itemText), children);
      }));
    }
  }]);

  return CheckboxGroup;
}(React.Component);

_defineProperty(CheckboxGroup, "defaultProps", {
  disabled: false,
  toggleAll: false,
  toggleAllText: 'All'
});

_defineProperty(CheckboxGroup, "propTypes", {
  id: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({
    value: SIMPLE_VALUE_PROP,
    text: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node
  })).isRequired,
  className: PropTypes.string,
  value: SIMPLE_ARRAY_PROP,
  disabled: PropTypes.oneOfType([PropTypes.bool, SIMPLE_ARRAY_PROP]),
  toggleAll: PropTypes.bool,
  toggleAllText: PropTypes.string,
  onChange: PropTypes.func
});

export default wire(normalizeList(CheckboxGroup), 'value', []);